<p>sales-management-select-customer works!</p>
